module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<br>\n<div class="col-sm-12 feature-static-content {{page.static_page ? page.static_page : \'\'}}" ng-bind-html="page.content"></div>\n\n<style>\n    .feature-static-content {\n        padding:5px 10px;\n        overflow:auto\n    }\n</style>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./src/app/features/pages/index.html
// module id = 314
// module chunks = 0